import React, { useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next"
import './crudTable.css'
import { LoadingContext, BufferService, M_Button, M_Select, M_DrawerTableTextField, M_InputTextField } from '../../../M_Components'
import { getRenderer } from "../../../components/field-renderers"

export function CrudTable({ metaType, entity, onGetWithFilters, onToastMessages, operation, setIsTable, rowEdit, setRowEdit, valueAdd, setValueAdd, isCopy, setIsCopy, editMap, setEditMap, row, parentLine, field, companies, hasConfirmation }) {
    const ctx = useContext(LoadingContext)
    const bufferService = new BufferService(entity)
    const companyBuffer = new BufferService('Company')
    const { t } = useTranslation()

    //* It comes from the modal of creation
    useEffect(() => {
        if (operation === 'Create') {
            handleOpenCreate()
        }

        if (operation === 'Edit' || operation === 'Copy') {
            handleOpenEdit()
        }
        if (operation === 'View') {
            handleOpenEdit()
        }
        // eslint-disable-next-line
    }, [])

    const handleOpenCreate = () => {
        if (valueAdd.size) { return }
        metaType.forEach((elem) => {
            valueAdd.set(elem.metaName, '')
        })
        if (companies.length == 1) {
            valueAdd.set('UserCompanyId', companies[0].Id)
            valueAdd.set('UserCompany', companies[0].Code)
        }
        setValueAdd(new Map(valueAdd))
    }

    const handleOpenEdit = () => {
        if (editMap.size) { return null }
        if (row) {
            setRowEdit(row)
            setEditMap(new Map(editMap.set('Id', row.Id)))
            metaType.forEach((elem) => {
                editMap.set(elem.metaName, row[elem.metaName])
            })
            if (row?.UserCompanyId) {
                editMap.set('UserCompanyId', row?.UserCompanyId)
                companyBuffer.getId(row?.UserCompanyId).then(companyRes => {
                    if (companyRes.name === 'AxiosError') {
                        ctx.toastMessages('error', companyRes.error, '')
                    }
                    editMap.set('UserCompany', companyRes.Code)
                    setEditMap(new Map(editMap))
                })
            } else {
                if (companies.length !== 0) {
                    if (companies.length > 1) {
                        editMap.set('UserCompanyId', '')
                        editMap.set('UserCompany', '')
                    } else {
                        editMap.set('UserCompanyId', companies[0].Id)
                        editMap.set('UserCompany', companies[0].Code)
                    }
                }
            }
            setEditMap(new Map(editMap))
        } else {
            setIsTable(true)
            ctx.toastMessages('error', '', t("SelectedMultiLine"))
        }
    }

    const updateCall = async (Id, data) => {
        const res = await bufferService.update(Id, data).then(data => { return data })
        const resData = await res
        return resData
    }

    const editValues = (name, value) => {
        setEditMap(new Map(editMap.set(name, value)))
    }

    //* transform edit Map to object and submit it to backend
    const submitEdit = () => {
        ctx.setIsLoad(true)
        if (isCopy) {
            addValue()
            return
        }
        if (parentLine) {
            editMap.set(field, rowEdit[field])
        }

        const tempObjt = Object.fromEntries(editMap)
        updateCall(tempObjt.Id, tempObjt).then(data => {
            if (data.name === 'AxiosError') {
                if (Array.isArray(data?.response?.data?.Errors?.toString())) {
                    ctx.toastMessages('error', data?.response?.data?.Errors?.toString(), 'Erro, ')
                } else {
                    ctx.toastMessages('error', data?.response?.data?.Errors, 'Erro, ')
                }
                ctx.setIsLoad(false)
            } else {
                cleanUp()
                setIsTable(true)
                ctx.toastMessages('success', '', t("Success"))
                getWithFilters()
                ctx.setIsLoad(false)
            }
        })
    }

    // create
    const post = async (data) => {
        const res = await bufferService.post(data).then(response => { return response })
        const dataRes = await res
        return dataRes
    }

    const addValueState = (key, value) => {
        setValueAdd(new Map(valueAdd.set(key, value)))
    }

    const addValue = () => {
        ctx.setIsLoad(true)
        let obj
        if (isCopy) {
            if (parentLine) {
                editMap.set(field, rowEdit[field])
            }
            obj = Object.fromEntries(editMap)
        } else {
            if (parentLine) {
                valueAdd.set(field, parentLine[0].Id)
            }
            obj = Object.fromEntries(valueAdd)
        }


        post(obj).then(data => {
            if (data.name === 'AxiosError') {
                if (Array.isArray(data?.response?.data?.Errors?.toString())) {
                    ctx.toastMessages('error', data?.response?.data?.Errors?.toString(), 'Erro, ')
                } else {
                    ctx.toastMessages('error', data?.response?.data?.Errors, 'Erro, ')
                }
                ctx.setIsLoad(false)
            } else {
                if (hasConfirmation) {
                    console.log('new endpoint')
                }
                ctx.setIsLoad(false)
                cleanUp()
                setIsTable(true)
                ctx.toastMessages('success', '', t("AddSuccess"))
                getWithFilters()
                if (isCopy) {
                    setIsCopy(false)
                }
            }
        })
    }

    const cleanUp = () => {
        setEditMap(new Map(editMap.clear()))
        setValueAdd(new Map(valueAdd.clear()))
        setIsTable(true)
    }

    const getWithFilters = () => {
        onGetWithFilters()
    }

    const refreshCrud = () => {
        if (operation === "Create") {
            valueAdd.clear()
            metaType.forEach((elem) => {
                valueAdd.set(elem.metaName, '')
            })
            setValueAdd(new Map(valueAdd))
        }
        if (operation === 'Edit' || operation === 'Copy') {
            bufferService.getId(editMap.get('Id')).then((data) => {
                editMap.clear()
                metaType.forEach((elem) => {
                    if (elem.metaName === 'UserCompanyId') {
                        companies.forEach(element => {
                            if (element.Id === data[elem.metaName]) {
                                editMap.set('UserCompany', element.Code)
                            }
                        })
                    }
                    editMap.set(elem.metaName, data[elem.metaName])
                })
                setEditMap(new Map(editMap))
            })
        }
    }

    const drawerEditValue = (elem) => {
        if (editMap.get(elem.metaForeignTableToPassId)) {
            let tempObj = {}
            tempObj.Id = editMap.get(elem.metaForeignTableToPassId)
            tempObj[elem.metaForeignKeyName] = editMap.get(elem.metaName)
            return tempObj
        } else {
            return null
        }
    }

    const drawerAddValue = (elem) => {
        if (valueAdd.get(elem.metaForeignTableToPassId)) {
            let tempObj = {}
            tempObj.Id = valueAdd.get(elem.metaForeignTableToPassId)
            tempObj[elem.metaForeignKeyName] = valueAdd.get(elem.metaName)
            return tempObj
        } else {
            return null
        }
    }

    return (
        <div className='mainDivCRUD'>
            <div className="display">
                <div className="menuIcon">
                    <M_Button
                        tooltip={t("Back")}
                        label={t("Back")}
                        icon={<i className="pi pi-arrow-left iconTable" style={{ color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                        onClick={() => cleanUp()}
                    />
                    <M_Button
                        tooltip={t("RefreshTable")}
                        label={operation === 'Create' ? t("Reset") : t("Refresh")}
                        icon={<i className="pi pi-refresh iconTable"></i>}
                        onClick={() => refreshCrud()}
                    />
                    {operation === 'Create' || operation === 'Copy' || operation === 'Edit' ?
                        <M_Button
                            tooltip={t("Save")}
                            label={t("Save")}
                            icon={<i className="pi pi-save iconTable"></i>}
                            onClick={() => {
                                if (operation === 'Create' || operation === 'Copy') addValue()
                                if (operation === 'Edit') submitEdit()
                            }}
                        />
                        : ''
                    }
                </div>
            </div >

            <div className='groupTextFields'>
                {operation === 'Edit' || operation === 'Copy' ?
                    metaType.map((elem, index) => {
                        if (elem.metaIsEdit === false) {
                            if (elem.metaName === 'UserCompanyId') {
                                if (companies.lenght !== 0) {
                                    return (
                                        companies.length == 1 ?
                                            <div key={index} className='textFieldStyle'>
                                                <M_InputTextField
                                                    label={'User Company'}
                                                    value={editMap.get('UserCompany') || ''}
                                                    disabled
                                                />
                                            </div>
                                            :

                                            <div key={index} className='textFieldStyle'>
                                                <M_Select
                                                    autocomplete
                                                    label={'Company'}
                                                    options={companies.map(company => { return { label: company.Code, value: company.Id, } })}
                                                    value={editMap.get('UserCompanyId') ?
                                                        {
                                                            label: editMap.get('UserCompany'),
                                                            value: editMap.get('UserCompanyId'),
                                                        }
                                                        : null}
                                                    required={true}
                                                    color={true && !editMap.get('UserCompany') ? 'var(--color-red)' : ''}
                                                    secondColor={true && !editMap.get('UserCompany') ? 'var(--color-red)' : ''}
                                                    onChangeValue={(value) => {
                                                        if (value) {
                                                            editValues('UserCompany', value.label)
                                                            editValues('UserCompanyId', value.value)
                                                        } else {
                                                            editValues('UserCompany', '')
                                                            editValues('UserCompanyId', '')
                                                        }
                                                    }}
                                                />
                                            </div>
                                    )
                                } else {
                                    return ('')
                                }
                            } else {
                                return (
                                    elem.metaIsForeignKey ?
                                        <div key={index} className='textFieldStyle'>
                                            <M_DrawerTableTextField
                                                tableLabel={elem.metaForeignTableName}
                                                label={elem.metaDisplay}
                                                value={drawerEditValue(elem)}
                                                entity={elem.metaForeignTableName}
                                                filterField={elem.metaForeignKeyName}
                                                labelFields={[elem.metaForeignKeyName] || []}
                                                onSubmitValue={(obj) => {
                                                    if (obj) {
                                                        editValues(elem.metaForeignTableToPassId, obj.Id)
                                                        editValues(elem.metaName, obj[elem.metaForeignKeyName])
                                                    } else {
                                                        editValues(elem.metaForeignTableToPassId, '')
                                                        editValues(elem.metaName, '')
                                                    }
                                                }}
                                                required={elem.metaIsRequired}
                                                color={elem.metaIsRequired && !editMap.get(elem.metaName) ? 'var(--color-red)' : ''}
                                                secondColor={elem.metaIsRequired && !editMap.get(elem.metaName) ? 'var(--color-red)' : ''}
                                            />
                                        </div>
                                        :
                                        elem.metaType === 'string' || elem.metaType === 'int32' || elem.metaType === 'decimal' ?
                                            <div key={index} className='textFieldStyle'>
                                                {(() => {
                                                    const Renderer = getRenderer(entity, { Name: elem.metaName });
                                                    return (
                                                        <Renderer
                                                            name={elem.metaName}
                                                            label={elem.metaDisplay}
                                                            map={editMap}
                                                            setMap={setEditMap}
                                                            required={!!elem.metaIsRequired}
                                                            maxNumbers={9}
                                                            minNumbers={Math.max(4, elem.metaMinLen || 4)}
                                                            disableNumberUntilPrefix={true}
                                                            type={elem.metaType}
                                                            value={editMap.get(elem.metaName) || ''}
                                                            onChange={e => editValues(elem.metaName, e.target.value)}
                                                            color={elem.metaIsRequired && !editMap.get(elem.metaName) ? 'var(--color-red)' : ''}
                                                            secondColor={elem.metaIsRequired && !editMap.get(elem.metaName) ? 'var(--color-red)' : ''}
                                                        />
                                                    );
                                                })()}
                                            </div>
                                            : ''
                                )
                            }
                        }
                        return null
                    })
                    : operation === "Create" ?
                        metaType.map((elem, index) => {
                            if (elem.metaIsEdit === false) {
                                if (!valueAdd.keys()) {
                                    return ''
                                }
                                if (elem.metaName === 'UserCompanyId') {

                                    return (
                                        companies.length == 1 ?
                                            <div key={index} className='textFieldStyle'>
                                                <M_InputTextField
                                                    label={'User Company'}
                                                    type={elem.metaType}
                                                    required={elem.metaIsRequired}
                                                    color={!elem.metaIsRequired && !valueAdd.get('UserCompany') ? 'var(--color-red)' : ''}
                                                    secondColor={!elem.metaIsRequired && !valueAdd.get('UserCompany') ? 'var(--color-red)' : ''}
                                                    value={valueAdd.get('UserCompany') || ''}
                                                    disabled
                                                />
                                            </div>
                                            :
                                            <div key={index} className='textFieldStyle'>
                                                <M_Select
                                                    autocomplete
                                                    label={'Company'}
                                                    options={companies.map(company => { return { label: company.Code, value: company.Id } })}
                                                    value={valueAdd.get('UserCompanyId') ?
                                                        {
                                                            label: valueAdd.get('UserCompany'),
                                                            code: valueAdd.get('UserCompanyId'),
                                                        } : null}
                                                    required={elem.metaIsRequired}
                                                    color={elem.metaIsRequired && !valueAdd.get('UserCompany') ? 'var(--color-red)' : ''}
                                                    secondColor={elem.metaIsRequired && !valueAdd.get('UserCompany') ? 'var(--color-red)' : ''}
                                                    onChangeValue={(obj) => {
                                                        if (obj) {
                                                            addValueState('UserCompanyId', obj.value)
                                                            addValueState('UserCompany', obj.label)
                                                        } else {
                                                            addValueState('UserCompanyId', '')
                                                            addValueState('UserCompany', '')
                                                        }
                                                    }}
                                                />
                                            </div>
                                    )
                                } else {
                                    return (
                                        elem.metaIsForeignKey ?
                                            <div key={index} className='textFieldStyle'>
                                                <M_DrawerTableTextField
                                                    tableLabel={elem.metaForeignTableName}
                                                    label={elem.metaDisplay}
                                                    value={drawerAddValue(elem)}
                                                    entity={elem.metaForeignTableName}
                                                    filterField={elem.metaForeignKeyName}
                                                    labelFields={[elem.metaForeignKeyName] || []}
                                                    onSubmitValue={(obj) => {
                                                        if (obj) {
                                                            addValueState(elem.metaForeignTableToPassId, obj.Id)
                                                            addValueState(elem.metaName, obj[elem.metaForeignKeyName])
                                                        } else {
                                                            addValueState(elem.metaForeignTableToPassId, '')
                                                            addValueState(elem.metaName, '')
                                                        }
                                                    }}
                                                    required={elem.metaIsRequired}
                                                    color={elem.metaIsRequired && !valueAdd.get(elem.metaName) ? 'var(--color-red)' : ''}
                                                    secondColor={elem.metaIsRequired && !valueAdd.get(elem.metaName) ? 'var(--color-red)' : ''}
                                                />
                                            </div>
                                            :
                                            elem.metaType === 'string' || elem.metaType === 'int32' || elem.metaType === 'decimal' ?
                                                <div key={index} className='textFieldStyle'>
                                                    <M_InputTextField
                                                        maxNumbers={elem.metaMaxLen}
                                                        label={elem.metaDisplay}
                                                        type={elem.metaType}
                                                        required={elem.metaIsRequired}
                                                        color={elem.metaIsRequired && !valueAdd.get(elem.metaName) ? 'var(--color-red)' : ''}
                                                        secondColor={elem.metaIsRequired && !valueAdd.get(elem.metaName) ? 'var(--color-red)' : ''}
                                                        value={valueAdd.get(elem.metaName) || ''}
                                                        onChange={e => addValueState(elem.metaName, e.target.value)}
                                                    />
                                                </div>
                                                : ''
                                    )
                                }
                            }
                            return null
                        })
                        : operation === 'View' ?
                            metaType.map((meta, index) => {
                                if (meta.metaIsEdit === false) {
                                    return (
                                        meta.metaName == 'UserCompanyId' ?
                                            <div key={index} className='textFieldStyle'>
                                                <M_InputTextField
                                                    label={'User Company'}
                                                    value={editMap.get('UserCompany') || ''}
                                                    disabled
                                                />
                                            </div>
                                            :
                                            meta.metaType === 'string' || meta.metaType === 'int32' ?
                                                <div key={index} className='textFieldStyle'>
                                                    <M_InputTextField
                                                        label={meta.metaDisplay}
                                                        value={editMap.get(meta.metaName) || ''}
                                                        disabled
                                                    />
                                                </div>
                                                : ''
                                    )
                                }
                                return null
                            })
                            : ""
                }
            </div>
            <br /><br /><br /><br /><br />
        </div >
    )
}
